import { createRouter, createWebHistory } from 'vue-router';
import MainLayout from '@/view/main/components/MainLayout.vue';
import HomeTabPage from '@/view/main/pages/HomeTabPage.vue';
import CardCategoryEntrancePage from '@/view/main/pages/CardCategoryEntrancePage.vue';
import CardTabPage from '@/view/main/pages/CardTabPage.vue';
import MineTabPage from '@/view/main/pages/MineTabPage.vue';
import HomeNetworkPage from '@/view/main/pages/HomeNetworkPage.vue';
import HomeNodePage from '@/view/main/pages/HomeNodePage.vue';
import WalletTopupPage from '@/view/wallet/pages/WalletTopupPage.vue';
import WalletTopupSelectCoinPage from '@/view/wallet/pages/WalletTopupSelectCoinPage.vue';
import WalletWithdrawPage from '@/view/wallet/pages/WalletWithdrawPage.vue';
import WalletWithdrawSuccessPage from '@/view/wallet/pages/WalletWithdrawSuccessPage.vue';
import WalletWithdrawSelectCoinPage from '@/view/wallet/pages/WalletWithdrawSelectCoinPage.vue';
import WalletAccountAssetsPage from '@/view/wallet/pages/WalletAccountAssetsPage.vue';
import WalletBillPage from '@/view/wallet/pages/WalletBillPage.vue';
import WalletBillDetailPage from '@/view/wallet/pages/WalletBillDetailPage.vue';
import InviteFriendsPage from '@/view/wallet/pages/InviteFriendsPage.vue';
import InviteRegisterPage from '@/view/wallet/pages/InviteRegisterPage.vue';
import InviteRewardDetailsPage from '@/view/wallet/pages/InviteRewardDetailsPage.vue';
import InviteRewardDetailPage from '@/view/wallet/pages/InviteRewardDetailPage.vue';
import InviteRecommendedUsersPage from '@/view/wallet/pages/InviteRecommendedUsersPage.vue';
import PointsTaskPage from '@/view/wallet/pages/PointsTaskPage.vue';
import WalletReceivePage from '@/view/wallet/pages/WalletReceivePage.vue';
import WalletTransferPage from '@/view/wallet/pages/WalletTransferPage.vue';
import WalletTransferOperatePage from '@/view/wallet/pages/WalletTransferOperatePage.vue';
import WalletTransferSuccessPage from '@/view/wallet/pages/WalletTransferSuccessPage.vue';
import WalletTransferSelectCoinPage from '@/view/wallet/pages/WalletTransferSelectCoinPage.vue';
import WalletBackupPage from '@/view/wallet/pages/WalletBackupPage.vue';
import WalletBackupPrivateKeyPage from '@/view/wallet/pages/WalletBackupPrivateKeyPage.vue';
import WalletAddTokenPage from '@/view/wallet/pages/WalletAddTokenPage.vue';
import WalletAddNftPage from '@/view/wallet/pages/WalletAddNftPage.vue';
import WalletNftDetailPage from '@/view/wallet/pages/WalletNftDetailPage.vue';
import WalletNftAssetViewPage from '@/view/wallet/pages/WalletNftAssetViewPage.vue';
import WalletNftSendPage from '@/view/wallet/pages/WalletNftSendPage.vue';
import CardOpenPage from '@/view/wallet/pages/CardOpenPage.vue';
import CardPlatformsPage from '@/view/wallet/pages/CardPlatformsPage.vue';
import PhysicalCardActivePage from '@/view/wallet/pages/PhysicalCardActivePage.vue';
import PhysicalTransferPage from '@/view/wallet/pages/PhysicalTransferPage.vue';
import CardBillPage from '@/view/card/pages/CardBillPage.vue';
import CardDetailPage from '@/view/card/pages/CardDetailPage.vue';
import CardTradeDetailPage from '@/view/card/pages/CardTradeDetailPage.vue';
import CardKycIntroPage from '@/view/card/pages/CardKycIntroPage.vue';
import CardKycAddressPage from '@/view/card/pages/CardKycAddressPage.vue';
import CardKycResultPage from '@/view/card/pages/CardKycResultPage.vue';
import CardKycWebviewPage from '@/view/card/pages/CardKycWebviewPage.vue';
import CardTransferPage from '@/view/card/pages/CardTransferPage.vue';
import CardInfoPage from '@/view/card/pages/CardInfoPage.vue';
import CardAtmPage from '@/view/card/pages/CardAtmPage.vue';
import CardUseInstructionPage from '@/view/card/pages/CardUseInstructionPage.vue';
import CardUnbindInfoPage from '@/view/card/pages/CardUnbindInfoPage.vue';
import CardUnbindListPage from '@/view/card/pages/CardUnbindListPage.vue';
import CardUnbindDetailPage from '@/view/card/pages/CardUnbindDetailPage.vue';
import CardUnbindHandlingPage from '@/view/card/pages/CardUnbindHandlingPage.vue';
import CardUnbindResultPage from '@/view/card/pages/CardUnbindResultPage.vue';
import PhysicalCardOrderPage from '@/view/card/pages/PhysicalCardOrderPage.vue';
import PhysicalCardAddressPage from '@/view/card/pages/PhysicalCardAddressPage.vue';
import PhysicalCardConfirmPage from '@/view/card/pages/PhysicalCardConfirmPage.vue';
import PhysicalCardOrderSuccessPage from '@/view/card/pages/PhysicalCardOrderSuccessPage.vue';
import PhysicalCardPendingPage from '@/view/card/pages/PhysicalCardPendingPage.vue';
import CourseCardApplyPage from '@/view/card/pages/CourseCardApplyPage.vue';
import CourseCardSuccessPage from '@/view/card/pages/CourseCardSuccessPage.vue';
import LoginPage from '@/view/auth/pages/LoginPage.vue';
import EmailAuthPage from '@/view/auth/pages/EmailAuthPage.vue';
import CreateWalletPage from '@/view/auth/pages/CreateWalletPage.vue';
import ImportWalletPage from '@/view/auth/pages/ImportWalletPage.vue';
import BackupMnemonicWarnPage from '@/view/auth/pages/BackupMnemonicWarnPage.vue';
import CreateMnemonicPage from '@/view/auth/pages/CreateMnemonicPage.vue';
import VerifyMnemonicPage from '@/view/auth/pages/VerifyMnemonicPage.vue';
import CreateWalletSuccessPage from '@/view/auth/pages/CreateWalletSuccessPage.vue';
import ForgotPayPasswordPage from '@/view/auth/pages/ForgotPayPasswordPage.vue';
import BindEmailPage from '@/view/auth/pages/BindEmailPage.vue';
import ArticleTodoPage from '@/view/article/pages/ArticleTodoPage.vue';
import ArticleReportPreview from '@/view/article/pages/ArticleReportPreview.vue';
import ReferralGuidePage from '@/view/article/pages/ReferralGuidePage.vue';
import LanguagePage from '@/view/mine/pages/LanguagePage.vue';
import AboutPage from '@/view/mine/pages/AboutPage.vue';
import SupportEmailPage from '@/view/mine/pages/SupportEmailPage.vue';
import SupportChatPage from '@/view/mine/pages/SupportChatPage.vue';
import MineKycPage from '@/view/mine/pages/MineKycPage.vue';
import MineCodePage from '@/view/mine/pages/MineCodePage.vue';
import SecuritySettingsPage from '@/view/mine/pages/SecuritySettingsPage.vue';
import ChangePayPasswordPage from '@/view/mine/pages/ChangePayPasswordPage.vue';
import SecurityPage from '@/view/mine/pages/SecurityPage.vue';
import ChangePasswordPage from '@/view/mine/pages/ChangePasswordPage.vue';
import { canGoBack } from '@/utils/navigation';
import { getSavedRouteState, saveRouteState } from '@/utils/route-state';

const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/iframe',
    redirect: '/home/index'
  },
  {
    path: '/referral-guide',
    name: 'referral-guide',
    component: ReferralGuidePage
  },
  {
    path: '/auth/email',
    name: 'auth-email',
    component: EmailAuthPage
  },
  {
    path: '/auth/create-wallet',
    name: 'auth-create-wallet',
    component: CreateWalletPage
  },
  {
    path: '/auth/import-wallet',
    name: 'auth-import-wallet',
    component: ImportWalletPage
  },
  {
    path: '/auth/backup-warn',
    name: 'auth-backup-warn',
    component: BackupMnemonicWarnPage
  },
  {
    path: '/auth/backup-mnemonic',
    name: 'auth-backup-mnemonic',
    component: CreateMnemonicPage
  },
  {
    path: '/auth/verify-mnemonic',
    name: 'auth-verify-mnemonic',
    component: VerifyMnemonicPage
  },
  {
    path: '/auth/wallet-success',
    name: 'auth-wallet-success',
    component: CreateWalletSuccessPage
  },
  {
    path: '/auth/forgot-pay-password',
    name: 'auth-forgot-pay-password',
    component: ForgotPayPasswordPage
  },
  {
    path: '/mine/security',
    name: 'mine-security',
    component: SecuritySettingsPage
  },
  {
    path: '/mine/security/change-password',
    name: 'mine-security-change-password',
    component: ChangePayPasswordPage
  },
  {
    path: '/auth/bind-email',
    name: 'auth-bind-email',
    component: BindEmailPage
  },
  {
    path: '/home',
    component: MainLayout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'home-index',
        component: HomeTabPage
      },
      {
        path: 'card',
        name: 'home-card',
        component: CardCategoryEntrancePage
      },
      {
        path: 'mine',
        name: 'home-mine',
        component: MineTabPage
      }
    ]
  },
  {
    path: '/card',
    redirect: '/card/index'
  },
  {
    path: '/card/index',
    name: 'card-index',
    meta: {
      routeStateNamespace: 'home-card'
    },
    component: CardTabPage
  },
  {
    path: '/home/network',
    name: 'home-network',
    component: HomeNetworkPage
  },
  {
    path: '/home/node',
    name: 'home-node',
    component: HomeNodePage
  },
  {
    path: '/mine/security',
    name: 'mine-security',
    component: SecurityPage
  },
  {
    path: '/mine/change-password',
    name: 'mine-change-password',
    component: ChangePasswordPage
  },
  {
    path: '/article/create',
    name: 'article-create',
    component: ArticleTodoPage,
    meta: {
      titleKey: 'article.create',
      descriptionKey: 'article.createTodo'
    }
  },
  {
    path: '/wallet/topup',
    name: 'wallet-topup',
    component: WalletTopupPage
  },
  {
    path: '/wallet/topup/select-coin',
    name: 'wallet-topup-select-coin',
    component: WalletTopupSelectCoinPage
  },
  {
    path: '/wallet/withdraw',
    name: 'wallet-withdraw',
    component: WalletWithdrawPage
  },
  {
    path: '/wallet/withdraw/success',
    name: 'wallet-withdraw-success',
    component: WalletWithdrawSuccessPage
  },
  {
    path: '/wallet/withdraw/select-coin',
    name: 'wallet-withdraw-select-coin',
    component: WalletWithdrawSelectCoinPage
  },
  {
    path: '/wallet/account-assets',
    name: 'wallet-account-assets',
    component: WalletAccountAssetsPage
  },
  {
    path: '/wallet/bill',
    name: 'wallet-bill',
    component: WalletBillPage
  },
  {
    path: '/wallet/bill/detail',
    name: 'wallet-bill-detail',
    component: WalletBillDetailPage
  },
  {
    path: '/wallet/invite-register',
    name: 'wallet-invite-register',
    meta: {
      preserveQuery: true
    },
    component: InviteRegisterPage
  },
  {
    path: '/wallet/invite',
    name: 'wallet-invite',
    component: InviteFriendsPage
  },
  {
    path: '/wallet/invite/reward',
    name: 'wallet-invite-reward',
    component: InviteRewardDetailsPage
  },
  {
    path: '/wallet/invite/reward/detail',
    name: 'wallet-invite-reward-detail',
    component: InviteRewardDetailPage
  },
  {
    path: '/wallet/invite/recommended-users',
    name: 'wallet-invite-recommended-users',
    component: InviteRecommendedUsersPage
  },
  {
    path: '/wallet/checkin',
    name: 'wallet-checkin',
    component: PointsTaskPage
  },
  {
    path: '/wallet/receive',
    name: 'wallet-receive',
    component: WalletReceivePage
  },
  {
    path: '/wallet/transfer',
    name: 'wallet-transfer',
    component: WalletTransferOperatePage
  },
  {
    path: '/wallet/transfer/success',
    name: 'wallet-transfer-success',
    component: WalletTransferSuccessPage
  },
  {
    path: '/wallet/transfer/select-coin',
    name: 'wallet-transfer-select-coin',
    component: WalletTransferSelectCoinPage
  },
  {
    path: '/wallet/token-detail',
    name: 'wallet-token-detail',
    component: WalletTransferPage
  },
  {
    path: '/wallet/add-token',
    name: 'wallet-add-token',
    component: WalletAddTokenPage
  },
  {
    path: '/wallet/add-nft',
    name: 'wallet-add-nft',
    component: WalletAddNftPage
  },
  {
    path: '/wallet/nft-detail',
    name: 'wallet-nft-detail',
    component: WalletNftDetailPage
  },
  {
    path: '/wallet/nft-view',
    name: 'wallet-nft-view',
    component: WalletNftAssetViewPage
  },
  {
    path: '/wallet/nft-send',
    name: 'wallet-nft-send',
    component: WalletNftSendPage
  },
  {
    path: '/wallet/backup',
    name: 'wallet-backup',
    component: WalletBackupPage
  },
  {
    path: '/wallet/backup/private-key',
    name: 'wallet-backup-private-key',
    component: WalletBackupPrivateKeyPage
  },
  {
    path: '/wallet/open-card',
    name: 'wallet-open-card',
    meta: {
      routeStateNamespace: 'card-open'
    },
    component: CardOpenPage
  },
  {
    path: '/wallet/open-card/platforms',
    name: 'wallet-open-card-platforms',
    meta: {
      routeStateNamespace: 'card-platforms'
    },
    component: CardPlatformsPage
  },
  {
    path: '/wallet/physical-active',
    name: 'wallet-physical-active',
    component: PhysicalCardActivePage
  },
  {
    path: '/wallet/physical-transfer',
    name: 'wallet-physical-transfer',
    component: PhysicalTransferPage
  },
  {
    path: '/card/bill',
    name: 'card-bill',
    component: CardBillPage
  },
  {
    path: '/card/bill/detail',
    name: 'card-bill-detail',
    component: CardTradeDetailPage
  },
  {
    path: '/card/detail',
    name: 'card-detail',
    component: CardDetailPage
  },
  {
    path: '/card/transfer',
    name: 'card-transfer',
    component: CardTransferPage
  },
  {
    path: '/card/info',
    name: 'card-info',
    component: CardInfoPage
  },
  {
    path: '/card/atm',
    name: 'card-atm',
    component: CardAtmPage
  },
  {
    path: '/card/use-instruction',
    name: 'card-use-instruction',
    meta: {
      routeStateNamespace: 'card-use-instruction'
    },
    component: CardUseInstructionPage
  },
  {
    path: '/card/unbind/info',
    name: 'card-unbind-info',
    component: CardUnbindInfoPage
  },
  {
    path: '/card/unbind/list',
    name: 'card-unbind-list',
    component: CardUnbindListPage
  },
  {
    path: '/card/unbind/detail',
    name: 'card-unbind-detail',
    component: CardUnbindDetailPage
  },
  {
    path: '/card/unbind/handling',
    name: 'card-unbind-handling',
    component: CardUnbindHandlingPage
  },
  {
    path: '/card/unbind/result',
    name: 'card-unbind-result',
    component: CardUnbindResultPage
  },
  {
    path: '/card/physical-order',
    name: 'card-physical-order',
    component: PhysicalCardOrderPage
  },
  {
    path: '/card/physical-order/address',
    name: 'card-physical-order-address',
    component: PhysicalCardAddressPage
  },
  {
    path: '/card/physical-order/confirm',
    name: 'card-physical-order-confirm',
    component: PhysicalCardConfirmPage
  },
  {
    path: '/card/physical-order/success',
    name: 'card-physical-order-success',
    component: PhysicalCardOrderSuccessPage
  },
  {
    path: '/card/physical-pending',
    name: 'card-physical-pending',
    component: PhysicalCardPendingPage
  },
  {
    path: '/card/course/apply',
    name: 'card-course-apply',
    component: CourseCardApplyPage
  },
  {
    path: '/card/course/success',
    name: 'card-course-success',
    component: CourseCardSuccessPage
  },
  {
    path: '/card/kyc',
    name: 'card-kyc',
    component: CardKycIntroPage
  },
  {
    path: '/card/kyc/address',
    name: 'card-kyc-address',
    component: CardKycAddressPage
  },
  {
    path: '/card/kyc/result',
    name: 'card-kyc-result',
    component: CardKycResultPage
  },
  {
    path: '/card/kyc/webview',
    name: 'card-kyc-webview',
    component: CardKycWebviewPage
  },
  {
    path: '/mine/kyc',
    name: 'mine-kyc',
    component: MineKycPage
  },
  {
    path: '/mine/language',
    name: 'mine-language',
    component: LanguagePage
  },
  {
    path: '/mine/code',
    name: 'mine-code',
    component: MineCodePage
  },
  {
    path: '/mine/about',
    name: 'mine-about',
    component: AboutPage
  },
  {
    path: '/mine/support-email',
    name: 'mine-support-email',
    component: SupportEmailPage
  },
  {
    path: '/mine/support-chat',
    name: 'mine-support-chat',
    component: SupportChatPage
  },
  {
    path: '/article/detail/:id',
    name: 'article-detail',
    component: ArticleTodoPage,
    meta: {
      titleKey: 'article.detail',
      descriptionKey: 'article.openDetailTodo'
    }
  },
  {
    path: '/article/report-preview',
    name: 'article-report-preview',
    component: ArticleReportPreview
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

function resolveRouteStateNamespace(route) {
  return String(
    route?.meta?.routeStateNamespace
    || route?.state?.__routeStateNamespace
    || route?.name
    || ''
  ).trim();
}

function normalizeQueryPayload(query = {}) {
  return Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined)
  );
}

router.beforeEach((to) => {
  if (to.meta?.preserveQuery) {
    return true;
  }

  const namespace = resolveRouteStateNamespace(to);
  const queryPayload = normalizeQueryPayload(to.query || {});

  if (!namespace || !Object.keys(queryPayload).length) {
    return true;
  }

  const currentStateKey = String(to.state?.__routeStateKey || '').trim();
  const mergedPayload = {
    ...getSavedRouteState(namespace, currentStateKey),
    ...queryPayload
  };
  const nextStateKey = saveRouteState(namespace, mergedPayload);

  return {
    path: to.path,
    params: to.params,
    hash: to.hash,
    replace: true,
    state: {
      ...(to.state || {}),
      __routeStateKey: nextStateKey,
      __routeStateNamespace: namespace
    }
  };
});

function resetViewportAfterRouteChange() {
  if (typeof window === 'undefined') {
    return;
  }

  const activeEl = document.activeElement;
  if (
    activeEl
    && typeof activeEl.blur === 'function'
    && (
      activeEl.tagName === 'INPUT'
      || activeEl.tagName === 'TEXTAREA'
      || activeEl.tagName === 'SELECT'
      || activeEl.isContentEditable
    )
  ) {
    activeEl.blur();
  }

  const resetScroll = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  resetScroll();
  requestAnimationFrame(resetScroll);
  window.setTimeout(resetScroll, 80);
  window.setTimeout(resetScroll, 180);
}

router.afterEach(() => {
  resetViewportAfterRouteChange();
});

const rawBack = router.back.bind(router);
router.back = function patchedBack() {
  if (canGoBack()) {
    rawBack();
    return;
  }

  router.replace('/home/index');
};

export default router;
